const EDUCATION_LEVELS = [
  'p',
  'm',
  'b',
  'a',
  'hs',
  'jhs',
  'el',
  'none',
  'o',
];

const SOCIAL = {
  linkedin: {
    title: 'LinkedIn',
  },
  twitter: {
    title: 'Twitter',
  },
  facebook: {
    title: 'Facebook',
  },
};

export {
  EDUCATION_LEVELS,
  SOCIAL,
};
